import { Card, H4, IconType, ListItemIconTile } from "@sellar-io/components";
import type { ReactNode } from "react";

export const EmptyStateCard = ({
  icon = "FORMAT_LIST_BULLETED",
  badge,
  title,
  description,
  children,
}: {
  icon?: IconType;
  badge?: ReactNode;
  title: string;
  description?: ReactNode;
  children: ReactNode;
}) => (
  <main className="min-h-full bg-zinc-100 px-4 py-8 dark:bg-zinc-950">
    <Card className="mx-auto flex max-w-230 flex-col gap-4 bg-white p-4 sm:p-6">
      <div className="flex items-start justify-between gap-4">
        <ListItemIconTile icon={icon} />
        {badge}
      </div>
      <div className="flex flex-col gap-2">
        <H4 className="font-semibold">{title}</H4>
        <div className="text-sm text-zinc-600">{description}</div>
      </div>
      <div className="flex flex-col items-start gap-3">{children}</div>
    </Card>
  </main>
);
